import React from 'react';
import { BrainIcon, HeartIcon, TargetIcon, ZapIcon } from 'lucide-react';
export function BenefitsSection() {
  return <section id="beneficios" className="py-20 bg-white" data-id="element-19">
      <div className="container mx-auto px-4" data-id="element-20">
        <div className="max-w-4xl mx-auto" data-id="element-21">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-16 text-purple-800" data-id="element-22">
            Lo Que Experimentarás
          </h2>
          <div className="grid md:grid-cols-2 gap-10" data-id="element-23">
            <div className="text-center" data-id="element-24">
              <div className="bg-purple-100 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-25">
                <BrainIcon size={40} className="text-purple-600" data-id="element-26" />
              </div>
              <h3 className="text-xl font-semibold mb-3 text-purple-800" data-id="element-27">
                Estados expandidos de conciencia
              </h3>
              <p className="text-gray-600" data-id="element-28">
                Accede a los estados cerebrales Theta, Alpha y Delta, donde
                ocurre la verdadera transformación.
              </p>
            </div>
            <div className="text-center" data-id="element-29">
              <div className="bg-purple-100 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-30">
                <HeartIcon size={40} className="text-purple-600" data-id="element-31" />
              </div>
              <h3 className="text-xl font-semibold mb-3 text-purple-800" data-id="element-32">
                Conexión espiritual profunda
              </h3>
              <p className="text-gray-600" data-id="element-33">
                Establece una claridad emocional estable y una conexión con tu
                verdadero ser.
              </p>
            </div>
            <div className="text-center" data-id="element-34">
              <div className="bg-purple-100 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-35">
                <TargetIcon size={40} className="text-purple-600" data-id="element-36" />
              </div>
              <h3 className="text-xl font-semibold mb-3 text-purple-800" data-id="element-37">
                Activación de fe y propósito
              </h3>
              <p className="text-gray-600" data-id="element-38">
                Despierta un enfoque claro y un sentido de propósito en tu vida
                diaria.
              </p>
            </div>
            <div className="text-center" data-id="element-39">
              <div className="bg-purple-100 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-40">
                <ZapIcon size={40} className="text-purple-600" data-id="element-41" />
              </div>
              <h3 className="text-xl font-semibold mb-3 text-purple-800" data-id="element-42">
                Resultados desde el primer día
              </h3>
              <p className="text-gray-600" data-id="element-43">
                Experimenta cambios reales con prácticas simples y potentes
                desde el inicio.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}